<template>
  <div class="flex flex-col w-full">
    <div class="flex items-center text-lg font-semibold" :class="{ 'flex-row-reverse': arabic }">
      {{ data.data.title }}
    </div>
    <div class="flex" :dir="arabic ? 'rtl' : 'ltr'">
      {{ data.data.description }}
    </div>
    <div class="flex flex-row flex-wrap mb-8" :class="{ 'justify-end': arabic }">
      <SingleCheckbox
        v-for="item in data.data.choices"
        :key="`${item.id}_${data.key}`"
        :id="`${item.id}_${data.key}`"
        :name="data.key"
        v-model="data.value"
        :value="item.id"
        @change="onChange"
        @toggle="
          () => {
            changed = true;
          }
        "
      >
        <p>{{ item.title }}</p>
      </SingleCheckbox>
    </div>
  </div>
</template>

<script>
import SingleCheckbox from "@/components/ui-kit/SingleCheckbox";
import storageClient from "@/services/storageClient";
import { getFilterEvents } from "../../utils/filter";

export default {
  name: "DynamicSingleChoice",
  components: {
    SingleCheckbox
  },

  props: {
    data: {
      type: Object
    }
  },
  computed: {
    arabic() {
      return storageClient.getLanguage() === "ar";
    },
    direction() {
      return this.arabic ? "rtl" : "ltr";
    }
  },
  methods: {
    async onChange(value) {
      await this.$store.dispatch("therapistFilterDynamic/setFilterOptionValue", {
        key: this.data.key,
        value: value
      });
      await this.$store.dispatch("therapistFilterDynamic/fetchTherapistsDynamic", 1);

      const trackData = getFilterEvents(this.$store.state.therapistFilterDynamic);

      window.webengage.track("therapistFilters_change", trackData);
      this.$mixpanel.track("therapistFilters_change", trackData);
      this.$intercom.trackEvent("therapistFilters_change", trackData);
    }
  }
};
</script>

<style lang="scss" scoped></style>
